module.exports = __webpack_public_path__ + "img/time.466b6ca4.svg";